import React from 'react';
import Pager from 'emerald-ui/lib/Pager';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: Pager, componentName: 'Pager' }], 'Pager'),
  description:
    'A Pager shows the number of pages in a query result and the current page, allows navigating through the pages and configuring the number of results per page. It is used mainly with a Table.',
  codeSamples: [
    {
      title: 'Default',
      scope: { Pager, React },
      code: `class FullPager extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      limit: 5,
      offset: 0
    };

    this.handleLimitChange = this.handleLimitChange.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  // You can use here an arrow function instead to avoid using binding in the constructor:
  // handleLimitChange = limit => {}
  handleLimitChange(limit) {
    console.log('limit changing:', limit);
    this.setState({
      offset: 0,
      limit: limit
    });
  }

  // You can use here an arrow function instead to avoid using binding in the constructor:
  // handlePageChange = (action, offset) => {}
  handlePageChange(action, offset) {
    this.setState({
      offset: offset
    });
  }

  render() {
    return (
      <Pager
        offset={this.state.offset}
        limit={this.state.limit}
        onPageChange={this.handlePageChange}
        onLimitChange={this.handleLimitChange}
        total={100}
      />
    );
  }
}`,
    },
  ],
};
